import {decode as base64_decode, encode as base64_encode} from 'base-64';
import RootStore from './RootStore';
import { postApi } from '../components/Utility'
import config from "../config";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
  observe,
} from 'mobx';
import { act } from 'react-dom/test-utils';
import axios from 'axios';

class AssignJobOrderStore {
  assignTrip=[]
  vehicles=[]
  geoDataArray=[]
  tripDataArray=[]
  total=0
  loading=false
  rootStore
  idlePoints=[]
  addr=""

  constructor(rootStore) {
    makeObservable(this, {
      idlePoints:observable,
        assignTrip: observable,
        geoDataArray:observable,
        vehicles:observable,
        tripDataArray:observable,
      total:observable,
      loading:observable,
      addr:observable,


      loadData:action,
      getAddressUsingLatLng:action,
      getAssignTrip:action,
      getVehicles:action,
      getGeoData:action,
      getStopeIdle:action,
      deleteJobOrder:action,
      getTripList:action


     
    });
     this.rootStore = rootStore;
    
  }
  async getCompany({companyName}){

    var postData = {"name":companyName}
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=company&a=searchCompany", "postData="+base64Input);
    console.log(response);

  }


  async loadData({companyId}){
    var postData = {"companyId":companyId,"offset":0,"limit":50,"page":1}
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=route&a=jobOrderList", "postData="+base64Input);
    console.log(response)
    this.jobDataArray= response.data.data.jobOrderList;
  }


async createTrip({obj,routePoints}){
  var postData = {"tokenId":"","AddRoute":obj, routePoints:routePoints}
  const base64Input = await base64_encode(JSON.stringify(postData));
  var response = await postApi.getClient().post("index.php?c=trip&a=create", "postData="+base64Input);
  console.log(response)
  return response
}
  async getVehicles(companyId){
    var postData = {"companyId":companyId}
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=vehicle&a=getVehicles", "postData="+base64Input);
    return response?.data?.data || [];
  }
async getGeoDataold(companyId,geoZoneId, vehicleId){
  var postData = {"companyId":companyId,geoZoneId:geoZoneId,vehicleId:vehicleId}
  const base64Input = await base64_encode(JSON.stringify(postData));
  var response = await postApi.getClient().post("index.php?c=geofence&a=geoData", "postData="+base64Input);
  this.geoDataArray = response.data.data.geofence;
}

async getStopeIdle(object){
  var postData = object
  const base64Input = await base64_encode(JSON.stringify(postData));
  var response = await postApi.getClient().post("index.php?c=trip&a=getstopidle", "postData="+base64Input);
  this.idlePoints = response.data?.data.StopIdleData
  console.log(response.data?.data)
  return response
}

async deleteJobOrder({stId}){
  var postData = {stId:stId}
  console.log(postData);
  const base64Input = await base64_encode(JSON.stringify(postData));
  var response = await postApi.getClient().post("index.php?c=route&a=deleteJob", "postData="+base64Input);
  return response;
}
 
  async getAssignTrip(schoolCalenderId){
    console.log("school Calender Id ", schoolCalenderId)
  }

  async getAssignTripRecord(stId){
    var postData = {stId:stId}
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=trip&a=getTripdata", "postData="+base64Input);
    console.log(response)
    return response.data?.data[0]
    // this.tripDataArray= response.data.data
  }

async getAddressUsingLatLng(lat,lng){
  let url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${config.googleMapKey}`;
     const response = await axios(url);
     let address = await response.data.results[0].formatted_address;

     this.addr = address
     return address
}

async getRouteList(companyId){
  var postData = {companyId:companyId}
  console.log(postData);
  const base64Input = await base64_encode(JSON.stringify(postData));
  var response = await postApi.getClient().post("index.php?c=route&a=routeList", "postData="+base64Input);
  return response;
}


    
  async getDeviceGroups( companyId ) {

    var postData = { companyId: companyId,limit:10,offset:0 }
    console.log(postData);
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=company&a=getDeviceGroups", "postData=" + base64Input);
    
    return response?.data?.data?.devicegroups || [];
  }

async getDrivers(companyId){
  var postData = {companyId:companyId}
  console.log(postData);
  const base64Input = await base64_encode(JSON.stringify(postData));
  var response = await postApi.getClient().post("index.php?c=driver&a=getDriver", "postData="+base64Input);
 return response?.data?.data || [];
}

async getGeoData(companyId){
  var postData = {
    companyId: companyId,
    searchField: "",
    offset:0,
    limit:100
  }
  console.log(postData);
  const base64Input = await base64_encode(JSON.stringify(postData));
  //var response = await postApi.getClient("").get(config.NodeUrl + "/taxi/geoData", { params: postData });
   const response = await postApi.getClient().post("index.php?c=geofence&a=geoData","postData=" + base64Input);
  return response.data;
}

async saveRoute({ AddRoute, routePoints }) {
  try {
    const postData = {
      tokenId: "",
      AddRoute,
      routePoints,
    };
    console.log("POST DATA RAW = ", postData);
    const base64Input = await base64_encode(JSON.stringify(postData));
    const response = await postApi.getClient().post("index.php?c=route&a=createJobOrder","postData=" + base64Input);
    console.log("API Response => ", response);
    return response;
  } catch (err) {
    console.log("SaveRoute error => ", err);
    return { data: { success: "F0" } };
  }
}

  async getJobOrderById(companyId,stId){
      var postData = {companyId:companyId,stId:stId,limit:10,offset:0}
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=route&a=jobOrderList", "postData="+base64Input);
    console.log(response);
    return response.data?.data?.jobOrderList[0];
    // this.tripDataArray= response.data.data
  }

 async getTripList(driverId,companyId){
      var postData = {driverId:driverId,companyId:companyId}
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=trip&a=getTripdataNewDriver", "postData="+base64Input);
    console.log(response);
    return response.data?.data;
    // this.tripDataArray= response.data.data
  }

  async getUnitsByGroup(groupIds, companyId) {
    var postData = { groupId: groupIds, companyId: companyId, offset: 0, limit: 100 }
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=vehicle&a=vehicledetails", "postData=" + base64Input);
    console.log(response);
    return response.data?.data?.vehicledetails;
    // this.tripDataArray= response.data.data
  }

  

}

export default AssignJobOrderStore;
